import { objectValues } from '~/web-frontend-core/base/lib';
import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import { STATE } from '~/web-frontend-core/api/const/base';
export const matchCategoryID = 'MATCH';
export const statisticCategoryID = 'STATISTICS';
export class CategoriesTypes extends Subscribtion {
    constructor() {
        super(...arguments);
        this.data = new Map();
    }
    select(matchID, categoryID) {
        const data = this.data.get(Number(matchID));
        if (!data) {
            throw new Error('Попытка выбрать тип категории незарегистрированного матча');
        }
        const selectedType = data[categoryID];
        objectValues(data)
            .filter((staticType) => staticType.popular === selectedType.popular)
            .forEach((staticType) => { staticType.isSelected = false; });
        selectedType.isSelected = true;
        this.notify(matchID);
    }
    getPopular(matchID) {
        return this.getData(matchID).filter((type) => type.popular === STATE.ENABLED);
    }
    getSelected(matchID) {
        return this.getData(matchID).find((state) => state.isSelected) || null;
    }
    getNotPopular(matchID) {
        return this.getData(matchID)
            .filter((type) => type.popular === STATE.DISABLED)
            .map((state) => [state.name, Object.assign(Object.assign({}, state), { matchID: state.matchId })]);
    }
    getData(matchID) {
        if (!this.data.has(Number(matchID))) {
            return [];
        }
        return objectValues(this.data.get(Number(matchID)) || {});
    }
    update(matchID, staticTypes) {
        if (staticTypes.length === 0) {
            return;
        }
        const matchState = {
            matchId: matchID,
            name: matchCategoryID,
            isSelected: true,
            isDisabled: staticTypes.every((state) => state.isDisabled),
            popular: STATE.ENABLED
        };
        const statisticState = {
            matchId: matchID,
            name: statisticCategoryID,
            popular: STATE.ENABLED,
            isDisabled: staticTypes.every((state) => state.isDisabled || state.popular === STATE.ENABLED)
        };
        const data = [matchState, ...staticTypes, statisticState]
            .reduce((state, staticType) => Object.assign(state, { [staticType.name]: staticType }), {});
        const notPopluarCategory = staticTypes.find(({ popular }) => popular === STATE.DISABLED);
        if (notPopluarCategory) {
            notPopluarCategory.isSelected = true;
        }
        this.data.set(matchID, data);
        this.notify(matchID);
    }
    disable(matchID, states) {
        const data = this.getData(matchID);
        data.filter((state) => state.matchId in states)
            .forEach((state) => { state.isDisabled = states[state.matchId]; });
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes.mobile/additional/categories/Types.mobile.js